import React from "react";
import { FONTS, fontSize } from "../../styles/fonts";
import { ReviewTranslations } from "./reviewTranslations";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { ReviewTranslatedFrom } from "./ReviewTranslatedFrom";
import { T } from "../../components/T";

export const PDPReviewCommentTranslationBar: React.FC<{
  isUsingTranslatedComment: string | null;
  showOriginal: boolean;
  commentLanguageIsoCode: string | null;
  onClick: () => void;
  t: ReviewTranslations;
  locale: SwarovskiOptikLocaleFrontend;
}> = ({ isUsingTranslatedComment, showOriginal, commentLanguageIsoCode, onClick, t, locale }) => {
  if (!(isUsingTranslatedComment && commentLanguageIsoCode)) {
    return null;
  }

  return (
    <div className="u-mt-8">
      <div
        css={css`
          display: flex;
          justify-content: space-between;

          ${CSS_MQ.atMostSm} {
            flex-direction: column;
            align-items: flex-start;
          }
        `}
      >
        <ReviewTranslatedFrom
          t={t}
          locale={locale}
          languageIsoCode={commentLanguageIsoCode}
          className={showOriginal ? "u-hidden" : undefined}
        />

        <button onClick={onClick} css={[FONTS.SwarovskiFutura300, fontSize.x2]} className="u-underline">
          {showOriginal ? <T>{t("showTranslatedMessage")}</T> : <T>{t("showOriginalMessage")}</T>}
        </button>
      </div>
    </div>
  );
};
